import { ResponseService } from './../services/response.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ApiService } from "../services/api.service";
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-main',
  templateUrl: './login-verification.component.html'
})
export class LoginVerificationComponent implements OnInit {
  public loading: Boolean = false;

  verifyLoginForm: FormGroup

  constructor(
    private router: Router,
    private responseService: ResponseService,
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
  ) {
    this.verifyLoginForm = new FormGroup({  
       code: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.apiService.get('/verification/send').subscribe(
      (response) => {
        this.responseService.success(false, response, false);
      },
      (error) => {
        this.responseService.error(error, this.verifyLoginForm);
      },
    );
  }

  checkCode() {
    this.apiService.post('/verification/verify', this.verifyLoginForm.value).subscribe(
      (response) => {
        if(this.localStorageService.get('redirectUrl') != null){
          this.router.navigateByUrl(this.localStorageService.get('redirectUrl'));
          this.localStorageService.remove('redirectUrl');
        }else{
          this.router.navigateByUrl('/panel');
        }
        this.responseService.success(true, response, false);
      },
      (error) => {
        this.responseService.error(error, this.verifyLoginForm);
      } 
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login-verification.component.ts